import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash/fp'
import classNames from 'classnames'

import { Link } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import Chip from '@material-ui/core/Chip'
import List from '@material-ui/core/List'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'

import {
  LockOpen as LogInIcon,
  Assignment as SignUpIcon,
  Mail as MailIcon,
  Home as HomeIcon,
  Menu as MenuIcon,
  GolfCourse as GamesIcon,
  AccountBox as ProfileIcon,
  Group as BuddiesIcon,
  EmojiEvents as GLFROpenIcon
  // Public as ClubsIcon
} from '@material-ui/icons'

import ScreenSizeLabel from '../components/ScreenSizeLabel'
import ProfileImage from '../components/profile/ProfileImage'

import { actions as authActions, selectors as authSelectors } from '../reducers/auth'
import { selectors as profileSelectors } from '../reducers/profile'

import { getUserProfilePicture } from '../config'

import DrawerMenuItemBase from '@fe/ui/Drawer/DrawerMenuItem'
import colors from '@fe/ui/colors'
import styles from '@fe/ui/styles/RootLayout'

import SnackBarRoot from '@fe/ui/SnackBarRoot'

import images from '../images'
const routes = {
  '': {
    name: 'Home'
  },
  games: {
    name: 'Games'
  },
  buddies: {
    name: 'Buddies'
  },
  clubs: {
    name: 'Clubs'
  },
  profile: {
    name: 'Profile'
  },
  offers: {
    name: 'Offers'
  },
  open: {
    name: 'GLFR Open'
  },
  signup: {
    name: 'Sign Up'
  },
  login: {
    name: 'Log in'
  }
}
const DrawerMenuItem = _.compose(
  connect(
    s => ({
      routeList: routes,
      isAdmin: true,
      roles: []
    })
  )
)(DrawerMenuItemBase)

const pathToTitle = (currentPath) => {
  const pathParts = _.split('/', currentPath)
  if (pathParts[1] === 'open') {
    return 'GLFR Open'
  }
  if (_.size(pathParts) === 2) {
    return 'Home'
  } else if (_.indexOf('games', pathParts) === 2) {
    if (_.size(pathParts) === 3) {
      return 'Games'
    } else {
      return 'Game Info'
    }
  } else if (_.indexOf('buddies', pathParts) === 2) {
    return 'Buddies'
  } else if (_.indexOf('profile', pathParts) === 2) {
    return 'Profile'
  } else {
    return 'my.GLFR'
  }
}

const RootLoadingScreen = () => (
  <div
    style={{
      backgroundColor: colors.white,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }}
  >
    <img alt='GLFR Logo' src='/static/media/glfr_paleblue.png' />
  </div>
)

const mailHref = _.flow(
  _.replace(/ /g, '%20'),
  _.replace(/\n/g, '%0d%0a'),
  _.replace(/\t/g, ''),
  _.replace(/\r/g, '')
)(`mailto:support@glfr.com?subject=Feedback for myGLFR&body=<Write your feedback or question here>

Browser: ${window.navigator.userAgent}
Platform: ${window.navigator.platform}
Version: ${process.env.REACT_APP_VERSION}
Date/Time: ${new window.Date()}
`)

const RootLayout = (props) => {
  const {
    classes,
    currentPath,
    currentUserHandle,
    bootstrap,
    logout,
    userName,
    isLoading,
    isUserLoaded,
    notBootstrapped,
    profile,
    children
  } = props
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const setClosed = React.useCallback(() => {
    setOpen(false)
  }, [setOpen])

  useEffect(() => {
    bootstrap()
  }, [bootstrap])

  const showProfile = Boolean(anchorEl)

  if (isLoading || notBootstrapped) {
    return <RootLoadingScreen />
  }

  const hasMembership = _.flow(
    _.get('apolloUser.memberships'),
    _.negate(_.isEmpty)
  )(profile)

  const glfrOpenCurrentItemId = hasMembership && `u/${currentUserHandle}`

  const drawerContents = (
    <>
      <div
        className={classes.drawerHeader}
        style={{
          margin: 6,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundImage: `url(${images.icons.glfrLogo})`
        }}
      />
      <Divider />
      {isUserLoaded && (
        <List className={classes.listRoot}>
          <DrawerMenuItem
            name='GLFR Profile'
            icon={<HomeIcon />}
            routes={['']}
            currentItemId={`u/${currentUserHandle}`}
            currentPath={currentPath}
            onClick={setClosed}
          />

          <DrawerMenuItem
            name='GLFR Open'
            icon={<GLFROpenIcon />}
            routes={['open']}
            currentItemId={glfrOpenCurrentItemId}
            currentPath={currentPath}
            onClick={setClosed}
          />

          <DrawerMenuItem
            name='Buddies'
            icon={<BuddiesIcon />}
            routes={['buddies']}
            currentItemId={`u/${currentUserHandle}`}
            currentPath={currentPath}
            onClick={setClosed}
          />

          <DrawerMenuItem
            name='Games'
            icon={<GamesIcon />}
            routes={['games']}
            currentItemId={`u/${currentUserHandle}`}
            currentPath={currentPath}
            onClick={setClosed}
          />

          <DrawerMenuItem
            name='Profile'
            icon={<ProfileIcon />}
            routes={['profile']}
            currentItemId={`u/${currentUserHandle}`}
            currentPath={currentPath}
            onClick={setClosed}
          />

          {/* One day they shall return */}
          {/* <DrawerMenuItem
            name='Offers'
            icon={<OffersIcon />}
            routes={['offers']}
            currentPath={currentPath}
            onClick={setClosed}
          /> */}

          {/*
          <DrawerMenuItem
            name='Clubs'
            icon={<ClubsIcon />}
            routes={['clubs']}
            currentItemId={currentUserHandle}
            currentPath={currentPath}
            onClick={setClosed}
          />
          */}
        </List>
      )}
      {!isUserLoaded && (
        <div className={classes.listRoot} style={{ display: 'flex', flexDirection: 'column', padding: 6 }}>
          <Typography variant='h6'>Don't have a GLFR user?</Typography>
          <Typography variant='h6'>Create one now - it is free!</Typography>
          <Typography>With a GLFR user you get:</Typography>
          <Typography color='primary' style={{ marginLeft: 6, fontWeight: 'bold' }} variant='subtitle1'>Course Guides</Typography>
          <Typography style={{ marginLeft: 12 }} variant='body2'>Over 500 courses are now in GLFR and more are added every day</Typography>
          <Typography color='primary' style={{ marginLeft: 6, fontWeight: 'bold' }} variant='subtitle1'>Score Card</Typography>
          <Typography style={{ marginLeft: 12 }} variant='body2'>Keep your score with a single click and focus on your game</Typography>
          <Typography color='primary' style={{ marginLeft: 6, fontWeight: 'bold' }} variant='subtitle1'>Multiplayer</Typography>
          <Typography style={{ marginLeft: 12 }} variant='body2'>Play online with your friends and compare your game</Typography>
          <Typography color='primary' style={{ marginLeft: 6, fontWeight: 'bold' }} variant='subtitle1'>Shot Tracker</Typography>
          <Typography style={{ marginLeft: 12 }} variant='body2'>Track every shot you take and replay your games like the pros</Typography>
          <Link to={`/signup?returnTo=${currentPath}`} style={{ marginTop: 12, marginBottom: 12 }}>
            <Chip
              avatar={<Avatar><SignUpIcon /></Avatar>}
              label='Sign Up'
              color='primary'
              clickable
              style={{ width: '100%', justifyContent: 'flex-start' }}
            />
          </Link>
          <Divider />
          <Typography>Already have a user?</Typography>
          <Link to={`/login?returnTo=${currentPath}`} style={{ marginTop: 12, marginBottom: 12 }}>
            <Chip
              avatar={<Avatar><LogInIcon /></Avatar>}
              label='Login'
              color='primary'
              clickable
              style={{ width: '100%', justifyContent: 'flex-start' }}
            />
          </Link>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
        <div style={{
          fontSize: 'smaller',
          color: colors.lightBlue,
          textAlign: 'center'
        }}
        >
          {process.env.REACT_APP_VERSION}
        </div>
        <a
          href={mailHref}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <MailIcon fontSize='small' color='primary' />
          <span style={{ padding: '1em', color: '#333', fontSize: '85%' }}>
            Give us feedback
          </span>
        </a>
      </div>
    </>
  )

  const pageTitle = pathToTitle(currentPath)

  return (
    <div className={classes.root}>
      <div className={classes.appFrame}>
        <AppBar position='fixed' className={classNames(classes.appBar, classes.appBarShift)}>
          <Toolbar style={{ height: 64, display: 'flex', justifyContent: 'flex-start' }}>
            <Hidden mdUp>
              <IconButton
                style={{ color: colors.white }}
                aria-label='open drawer'
                onClick={() => setOpen(open => !open)}
              >
                <MenuIcon />
              </IconButton>
            </Hidden>

            <div style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', display: 'flex' }}>
              <Typography variant='h6' color='inherit'>
                {pageTitle}
              </Typography>
            </div>

            {isUserLoaded && (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <Button
                  aria-owns={showProfile ? 'menu-appbar' : null}
                  aria-haspopup='true'
                  onClick={(e) => {
                    setAnchorEl(e.currentTarget)
                  }}
                  variant='text'
                  color='inherit'
                >
                  <Hidden mdDown>
                    <Typography variant='h6' style={{ color: colors.white, textTransform: 'none', marginRight: '0.5em' }}>
                      {userName}
                    </Typography>
                  </Hidden>

                  <ProfileImage backgroundColor={colors.white} textColor={colors.primaryDarkGreen} size={40} />
                </Button>
                <Menu
                  id='menu-appbar'
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  open={showProfile}
                  onClose={() => setAnchorEl(null)}
                >
                  <MenuItem onClick={() => setAnchorEl(null)} component={Link} to={`/u/${currentUserHandle}/profile`}>Profile</MenuItem>
                  <MenuItem onClick={logout}>Logout</MenuItem>
                </Menu>
              </div>
            )}
          </Toolbar>
        </AppBar>

        <Hidden mdUp>
          <Drawer
            variant='temporary'
            anchor='left'
            open={open}
            onClose={setClosed}
            ModalProps={{
              keepMounted: true // Better open performance on mobile.
            }}
          >
            {drawerContents}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation='css'>
          <Drawer
            variant='permanent'
            open
          >
            {drawerContents}
          </Drawer>
        </Hidden>

        <div className={classNames(classes.content, classes.contentShift, classes.contentNoPadding)}>
          {/* <React.Suspense fallback={<LoadingPage />}> */}
          <React.Suspense fallback={<h1>Loading</h1>}>
            {children}
            <ScreenSizeLabel style={{ color: colors.secondaryDarkGrey, float: 'right' }} />
          </React.Suspense>
        </div>
      </div>
      <SnackBarRoot />
    </div>
  )
}

export default _.compose(
  withStyles(styles),
  connect(
    (s) => ({
      currentPath: _.get('router.location.pathname', s),
      userName: _.flow(profileSelectors.getProfile, _.getOr('NO USER FOUND', 'name'))(s),
      isUserLoaded: profileSelectors.isUserLoaded(s),
      isLoading: authSelectors.isLoading(s),
      notBootstrapped: authSelectors.notBootstrapped(s),
      currentUserHandle: profileSelectors.getProfileHandle(s),
      userImage: getUserProfilePicture(profileSelectors.getProfile(s)),
      profile: profileSelectors.getProfile(s)
    }),
    (d) => ({
      bootstrap: () => d(authActions.bootstrapRequest()),
      logout: () => d(authActions.logout())
    })
  )
)(RootLayout)
